import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { withFormik, FormikProps } from 'formik';
import { Grid, Box, MenuItem } from '@material-ui/core';
import { translate } from 'helpers/intl';
import validationSchema from 'containers/ContactUsPage/Body/ValidationSchema';
import messages from 'containers/ContactUsPage/messages';
import { OrangeButton } from 'components/Button';
import { StyledGrid } from 'containers/ContactUsPage/styles';
import get from 'lodash/get';
import SelectInputField from 'components/SelectInputField';
import InputField from 'components/InputField';

const ContactUsForm = (props: {} & FormikProps<FormValues>) => {
  const ObjectTypes = [
    {
      value: '0',
      label: translate(get(messages, 'demandeInfo'), props),
    },
    {
      value: '1',
      label: translate(get(messages, 'subscription'), props),
    },
    {
      value: '2',
      label: translate(get(messages, 'reclamation'), props),
    },
    {
      value: '3',
      label: translate(get(messages, 'others'), props),
    },
  ];
  const {
    values,
    touched,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
  } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Grid container justify="center">
        <Grid item xs={12}>
          <Box mb={3}>
            <SelectInputField
              name="object"
              label={translate(get(messages, 'object'), props)}
              onChange={handleChange}
              value={values.object}
              data={ObjectTypes}
              handleBlur={handleBlur}
              Children={[...ObjectTypes].map((item: any) => (
                <MenuItem value={item.value} key={item.label}>
                  {item.label}
                </MenuItem>
              ))}
            />
          </Box>
        </Grid>

        <Grid item xs={12}>
          <InputField
            name="message"
            multiline
            rows={12}
            placeholder={translate(get(messages, 'message'), props)}
            value={values.message}
            error={errors.message && touched.message}
            helperText={touched.message && errors.message}
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
        </Grid>
      </Grid>

      <StyledGrid container justify="flex-end">
        <Grid item xs={3}>
          <OrangeButton type="submit" variant="contained">
            {translate(get(messages, 'send'), props)}
          </OrangeButton>
        </Grid>
      </StyledGrid>
    </form>
  );
};

export interface FormProps {
  intl: IntlShape;
}

interface FormValues {
  object: string;
  message: string;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    return {
      object: '0',
      message: '',
    };
  },
  validationSchema,
  handleSubmit: (values, { props }) => {},
})(ContactUsForm);

export default injectIntl(Form);
